//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PricingCards from '@/components/elements/PricingCards.vue';
import AppFeaturesComparison from '@/components/AppFeaturesComparison.vue';
import CallToAction from '@/components/elements/CallToAction.vue';

const planPrices = require('~/content/raw/plan-prices.js');

// Builds schema.org Offers straight from the same price data the pricing
// cards render, so the structured data can't drift from what's on the page.
function buildOffers() {
  const centsToAmount = (cents) => (cents / 100).toFixed(2);

  const offers = [
    {
      '@type': 'Offer',
      name: 'FREE',
      price: '0.00',
      priceCurrency: 'EUR',
      url: 'https://bomist.com/pricing',
      description: 'Single user, limited to 100 parts and 3 products.'
    }
  ];

  ['MAKER', 'PRO', 'TEAM'].forEach((planName) => {
    planPrices[planName]
      .filter((plan) => plan.currency === 'eur')
      .forEach((plan) => {
        offers.push({
          '@type': 'Offer',
          name: `${planName} (billed ${plan.interval}ly)`,
          price: centsToAmount(plan.amount),
          priceCurrency: 'EUR',
          url: 'https://bomist.com/pricing'
        });
      });
  });

  const enterprise = planPrices.ENTERPRISE.find(
    (plan) => plan.currency === 'eur'
  );
  offers.push({
    '@type': 'Offer',
    name: 'ENTERPRISE (billed yearly)',
    price: centsToAmount(enterprise.amount),
    priceCurrency: 'EUR',
    url: 'https://bomist.com/pricing',
    description: 'Starting price, billed yearly. Contact sales for a quote.'
  });

  return offers;
}

export default {
  components: { PricingCards, AppFeaturesComparison, CallToAction },
  head() {
    return {
      title: 'Pricing | BOMIST',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            'Flexible pricing plans for every team size. Start free and upgrade when you need more. Every paid plan includes a 14-day PRO trial and 30-day money-back guarantee.'
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            name: 'BOMIST',
            url: 'https://bomist.com',
            applicationCategory: 'BusinessApplication',
            operatingSystem: 'Windows, macOS, Linux',
            description:
              'Inventory, BOM, procurement and production management software for electronics manufacturing teams.',
            offers: buildOffers()
          }
        }
      ]
    };
  }
};
